module.exports = __webpack_public_path__ + "media/img/uploads/solutions-slant-military-63af5eb1f1f56a145d44be477db63234.jpg";